import PassengerAddRequest, {
  PassengerAddRequestPassenger,
  PassengerAddRequestPassengerAddress,
} from "../../../api/raily/passenger/add/passenger-add-request";
import PassengerAddParams, {
  PassengerAddParamsPassenger,
  PassengerAddParamsPassengerAddress,
} from "./passenger-add-params";

const createAddress = (
  address: PassengerAddParamsPassengerAddress,
): PassengerAddRequestPassengerAddress => {
  return {
    apartment: address.apartment,
    country: address.country,
    houseNo: address.houseNo,
    lat: address.lat,
    lon: address.lon,
    street: address.street,
    town: address.town,
    zipCode: address.zipCode,
    description: address.description,
  };
};

const createPassenger = (
  passenger: PassengerAddParamsPassenger,
): PassengerAddRequestPassenger => {
  return {
    addresses: passenger.addresses.map(createAddress),
    dispatchIds: passenger.dispatchIds,
  };
};

const createRequest = (params: PassengerAddParams): PassengerAddRequest => {
  return {
    email: params.email,
    firstName: params.firstName,
    lastName: params.lastName,
    passenger: createPassenger(params.passenger),
    password: params.password,
    username: params.username,
    mobilePrimary: params.mobilePrimary,
    mobilePrimaryPrefix: params.mobilePrimaryPrefix,
    mobileSecondary: params.mobileSecondary,
    mobileSecondaryPrefix: params.mobileSecondaryPrefix,
  };
};

const passengerAddParamsFactory = {
  createRequest,
};

export default passengerAddParamsFactory;
